import { Button, Grid } from '@material-ui/core';
import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import addInfoToAgreement from '../../../../api/Purchasers/addInfoToAgreement.api';
import { getFormItems } from '../../../../redux/forms/actions';
import { validateEmail } from '../../../../utils/validateEmail';
import styles from './ClientsForm.module.scss';
import _ from 'lodash';
import { setAlert } from '../../../../redux/alerts/action';
import {
	validatePhoneNumber,
	reformatPhoneString,
} from '../../../../utils/validatePhoneNumber';
import { checkEmptyRequiredFields } from '../../../../utils/checkForValueInJson';

const ClientsForm = ({
	// parent props
	formId,
	leadId,
	isEditClientForms,
	show,
	closeFormModal,
	// redux
	getFormItems,
	initializeFormItems,
	formFields,
	coBrokerData,
	lawyerData,
	mortgageData,
	setAlert,
	error,
	setError,
	formData,
	setFormData,
}) => {
	const fields = formId && formFields?.[formId]?.['fields'];
	const [title, setTitle] = useState();

	useEffect(() => {
		setFormData(
			formId === 'cobroker'
				? coBrokerData
				: formId === 'lawyer'
				? lawyerData
				: mortgageData
		);
	}, [formId, coBrokerData, lawyerData, mortgageData]);

	useEffect(() => {
		getFormItems('purchasers', 'clientDetails');
		if (formId === 'cobroker') {
			setTitle('Co-Broker');
		} else if (formId === 'lawyer') {
			setTitle('Lawyer');
		} else if (formId === 'mortgage') {
			setTitle('Mortgage');
		}
	}, [formId]);

	useEffect(() => {
		console.log('Form dataa', formData);
	}, [formData]);

	const onChange = (e) => {
		let value = e.target.value;
		if (value === '') {
			setError({ ...error, [e.target.name]: true });
		} else {
			error && delete error[e.target.name];
		}

		if (e.target.name === 'emailAddress') {
			if (validateEmail(e.target.value) !== true || value === '') {
				setError({ ...error, [e.target.name]: true });
			} else {
				error && delete error[e.target.name];
			}
		}
		if (e.target.name === 'phoneNumber') {
			if (validatePhoneNumber(e.target.value) !== true || value === '') {
				setError({ ...error, [e.target.name]: true });
			} else {
				value = reformatPhoneString(e.target.value);
				error && delete error[e.target.name];
			}
		}
		if (e.target.name === 'mortgageValue') {
			if (e.target.value < 0 || value === '') {
				setError({ ...error, [e.target.name]: true });
			} else {
				error && delete error[e.target.name];
			}
		}
		if (e.target.name === 'commission') {
			if (e.target.value < 0 || value === '') {
				setError({ ...error, [e.target.name]: true });
			} else {
				error && delete error[e.target.name];
			}
		}

		setFormData({ ...formData, [e.target.name]: value });
	};

	const validateForm = () => {
		let error = {};
		if (
			(formData.emailAddress &&
				validateEmail(formData.emailAddress) !== true) ||
			formData.emailAddress === ''
		) {
			error.emailAddress = true;
		}
		if (
			(formData.phoneNumber &&
				validatePhoneNumber(formData.phoneNumber) !== true) ||
			formData.phoneNumber === ''
		) {
			error.phoneNumber = true;
		}
		if (formData.mortgageValue < 0 || formData.mortgageValue === '') {
			error.mortgageValue = true;
		}
		if (formData.commission < 0 || formData.commission === '') {
			error.commission = true;
		}
		return error;
	};

	const handleAddDoc = (e) => {
		e.preventDefault();
		let formError = validateForm();
		let chkFields = checkEmptyRequiredFields(formData, fields);
		if (
			!_.isEmpty(chkFields) ||
			!_.isEmpty(error) ||
			!_.isEmpty(formError)
		) {
			setError({ ...chkFields, ...error, ...formError });
		} else {
			addInfoToAgreement(leadId, formId, formData, isEditClientForms);
			closeFormModal(leadId);
		}
	};

	return (
		<div>
			<div className={styles.title}>
				{isEditClientForms ? `Edit ${title}` : `Add ${title}`}
			</div>
			<form
				onSubmit={handleAddDoc}
				method='POST'
				className={styles.clientInfoFormWrapper}
			>
				<Grid
					className={styles.clientInfoForm}
					display='flex'
					flexDirection='row'
					justifyContent='flex-start'
					flexWrap='wrap'
					textAlign='left'
					container
					spacing={3}
				>
					{formId &&
						formData !== undefined &&
						fields?.map((field) => (
							<Grid item className={styles.formItem} xs={6}>
								<TextField
									label={field?.formLabel}
									name={field?.formName}
									value={formData[field?.formName]}
									variant='outlined'
									onChange={(e) => onChange(e)}
									type={field?.formType}
									InputLabelProps={{
										shrink: field?.shrink,
									}}
									className={styles.textField}
									fullWidth
									required={
										field.required === true ? true : false
									}
									error={
										error && error[field?.formName] === true
											? true
											: false
									}
									helperText={
										error &&
										error[field?.formName] === true &&
										field?.errorMessage
									}
								/>
							</Grid>
						))}
				</Grid>
				<Button type='submit' className={styles.addBtn}>
					Add
				</Button>
			</form>
		</div>
	);
};

const mapStateToProps = (state) => ({
	formFields: state.forms.form.clientDetails,
	coBrokerData:
		state.agreement.agreementById?.cobroker ||
		state.forms.form.clientDetails?.cobroker?.formData,
	lawyerData:
		state.agreement.agreementById?.lawyer ||
		state.forms.form.clientDetails?.lawyer?.formData,
	mortgageData:
		state.agreement.agreementById?.mortgage ||
		state.forms.form.clientDetails?.mortgage?.formData,
});

export default connect(mapStateToProps, {
	getFormItems,
	setAlert,
})(ClientsForm);
